import $ from 'jquery';
import moment from 'moment';
import browser from '@openclassrooms/utils/browser';

import widgetFactory from '../../Widgets/widgetFactory';

const widgetName = 'calendarSelect';
const MIN_REQUIRED_AGE = 15;
const MAXIMUM_AGE = 100;
const actualYear = new Date().getFullYear();
const startYear = actualYear - MAXIMUM_AGE;
const endYear = actualYear - MIN_REQUIRED_AGE;

function isDatepickerLanguageAvailable(language) {
  return !!$.datepicker.regional[language];
}

function setLanguage(language) {
  $.datepicker.setDefaults($.datepicker.regional[language]);
}

const widget = widgetFactory(widgetName, {
  options: {
    onDateSelected: $.noop,
    classname: 'dateSelect',
    datepickerOptions: {
      yearRange: startYear + ':' + endYear,
    },
  },

  _create: function () {
    this._super();
    this.language = $('html').attr('lang') || '';
    this.defaultLang = 'en';

    // autodetect current language
    if (this.language && isDatepickerLanguageAvailable(this.language)) {
      setLanguage(this.language);
    } else {
      this.language = this.defaultLang;
      setLanguage(this.defaultLang);
    }

    this._setSelect();
    this._populateCorrectMonthsNames();
    this._createCalendarOpenLink();
    this._createCalendar();
    this._addEvents();

    this.element.css('visibility', 'visible');
  },

  _setSelect: function () {
    var $selects = $('select', this.element).addClass(this.options.classname + '__select');

    this.elements.$daySelector = $selects.filter('[name*="[day]"]');
    this.elements.$monthSelector = $selects.filter('[name*="[month]"]');
    this.elements.$yearSelector = $selects.filter('[name*="[year]"]');

    this.options.datepickerOptions.yearRange = this._computeYearRange();

    if (this.elements.$daySelector.is(':disabled')) {
      this.disable();
    }
  },

  _computeYearRange: function () {
    const $yearOptions = this.elements.$yearSelector.find('option[value!=""]');
    let startYear = $yearOptions.last().val();
    let endYear = $yearOptions.first().val();

    if (startYear === endYear) {
      return undefined;
    }

    if (startYear > endYear) {
      [startYear, endYear] = [endYear, startYear];
    }

    return startYear + ':' + endYear;
  },

  _verifyAgeLimit: function () {
    const errorMessage = browser.document.querySelector('.js-dobError');

    if (!errorMessage) {
      return;
    }

    const submitButton = browser.document.querySelector('.editProfile__buttonSave');
    const $yearOptions = this.elements.$yearSelector.find('option:selected');
    const $monthOptions = this.elements.$monthSelector.find('option:selected');
    const $dayOptions = this.elements.$daySelector.find('option:selected');

    const year = $yearOptions.val();
    const month = $monthOptions.val() - 1;
    const day = $dayOptions.val();

    const currentAge = moment().diff([year, month, day], 'years');

    if (currentAge < MIN_REQUIRED_AGE) {
      errorMessage.style.display = 'block';
      submitButton.disabled = true;
    } else {
      errorMessage.style.display = 'none';
      submitButton.disabled = false;
    }
  },

  _populateCorrectMonthsNames: function () {
    var self = this;

    $('option', this.elements.$monthSelector).each(function (n, element) {
      var $option = $(element);
      if (isDatepickerLanguageAvailable(self.language)) {
        $(element).text($.datepicker.regional[self.language].monthNames[$option.val() - 1]);
      }
    });
  },

  _addEvents: function () {
    var events = {};

    events['click .js-calendar-select-opener'] = function () {
      if (this.isDisabled) {
        return false;
      }
      this._setCalendarOpenState(!this.elements.$calendar.is(':visible'));
    };

    events['change select'] = function () {
      if (this.hasAllSelectSelected()) {
        this._trigger('onDateSelected');
        this._verifyAgeLimit();
      }
    };

    this._on(this.element, events);
  },

  _createCalendarOpenLink: function () {
    this.elements.$calendarLink = $('.js-calendar-select-opener', this.element);

    if (!this.elements.$calendarLink.length) {
      this.elements.$calendarLink = $('<a><span></span></a>')
        .addClass('js-calendar-select-opener')
        .find('span')
        .text('calendrier')
        .parent()
        .appendTo(this.element);
    }

    this.elements.$calendarLink.addClass(this.options.classname + '__calendar-link');
  },

  _createCalendar: function () {
    var self = this;

    this.elements.$calendar = $('<div>')
      .hide()
      .addClass(this.options.classname + '__calendar-container')
      .appendTo(this.element);

    this.elements.$calendar.datepicker(
      $.extend(this.options.datepickerOptions, {
        dateFormat: 'yy-mm-dd',
        changeMonth: true,
        changeYear: true,
        nextText: '',
        prevText: '',
        onSelect: function () {
          var date = $(this).datepicker('getDate');
          self._setCalendarOpenState(false);
          self.setDate(date);
          self._trigger('onDateSelected');
          self._verifyAgeLimit();
        },
      })
    );
  },

  _setSelectsDisableState: function (state) {
    this.elements.$daySelector.prop('disabled', !state);
    this.elements.$monthSelector.prop('disabled', !state);
    this.elements.$yearSelector.prop('disabled', !state);
  },

  _getSelectsDate: function () {
    var elements = this.elements,
      day = parseInt(elements.$daySelector.val(), 10),
      month = parseInt(elements.$monthSelector.val(), 10) - 1,
      year = parseInt(elements.$yearSelector.val(), 10),
      date = isNaN(day) || isNaN(month) || isNaN(year) ? new Date() : new Date(year, month, day);

    return date;
  },

  _setCalendarOpenState: function (state) {
    var handler = $.proxy(this._outsideClickHandler, this);

    this.elements.$calendar.toggle(state);

    if (state) {
      this._setSelectsDisableState(false);
      this.elements.$calendar.datepicker('setDate', this._getSelectsDate());

      $(document).on('click', handler);
    } else {
      this._setSelectsDisableState(true);
      $(document).off('click', handler);
    }
  },

  _outsideClickHandler: function (event) {
    var isInside = $.contains(this.element.get(0), event.target),
      isCalendar = !!$(event.target).closest('.ui-datepicker-header').length;

    if (!isInside && !isCalendar) {
      this._setCalendarOpenState(false);
    }
  },

  _setEnableState: function (state) {
    var isDisabled = !state;
    this.elements.$daySelector.prop('disabled', isDisabled);
    this.elements.$monthSelector.prop('disabled', isDisabled);
    this.elements.$yearSelector.prop('disabled', isDisabled);
  },

  hasAllSelectSelected: function () {
    return (
      this.elements.$daySelector.val() !== '' &&
      this.elements.$monthSelector.val() !== '' &&
      this.elements.$yearSelector.val() !== ''
    );
  },

  setDate: function (date) {
    var day = date.getDate(),
      month = date.getMonth() + 1,
      year = date.getFullYear();

    this.elements.$daySelector.val(day);
    this.elements.$monthSelector.val(month);
    this.elements.$yearSelector.val(year);
  },

  reset: function () {
    this.elements.$daySelector.val('');
    this.elements.$monthSelector.val('');
    this.elements.$yearSelector.val('');
  },

  enable: function () {
    this._super();
    this._setEnableState(true);
  },

  disable: function () {
    this._super();
    this._setEnableState(false);
  },
});

export default widget;
